const getLocalRefreshToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user.tokens.refresh.token;
};

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user.token;
};

const updateLocalAccessToken = (token) => {
  const user = JSON.parse(localStorage.getItem("user"));
  user.tokens = token;
  localStorage.setItem("user", JSON.stringify(user));
};

const getUser = () => JSON.parse(localStorage.getItem("user"));

const setUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const removeUser = () => localStorage.removeItem("user");

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
